import React from "react";
import { Link } from "react-router-dom";
import { SectieBalk } from "@/components/overzicht/NuParts";
import { Tegel, KNOP_IN_KOP } from "@/components/rust/Rust";

export { SectieBalk };

export const Teller = Tegel;   // v18-D2

export const Leeg = ({ children }) => <p className="text-[13px] text-zinc-500 bg-white border border-zinc-200 rounded-[10px] px-3 py-[9px]">{children}</p>;

export function AfspraakLijst({ items, testid, leeg }) {
  if (!items?.length) return <Leeg>{leeg}</Leeg>;
  return (
    <ul data-testid={testid} className="bg-white border border-zinc-200 rounded-[10px] divide-y divide-zinc-200">
      {items.map((a) => (
        <li key={a.id}>
          <Link to={`/afspraken?select=${a.id}`} data-testid={`${testid}-${a.id}`} className="flex flex-wrap items-center gap-x-3 gap-y-0.5 px-3 py-[9px] text-[13px] hover:bg-zinc-50 transition-colors">
            <span className="flex-1 min-w-[160px] text-zinc-800 truncate">{a.wat}</span>
            <span className="text-xs text-zinc-500">{a.soort === "intern" ? "intern" : a.locatie}</span>
            <span className={`font-mono text-xs ${a.dagenTeLaat > 0 ? "text-rose-600 font-bold" : a.wachtOpOmLabel ? "text-blue-700 font-semibold" : "text-zinc-500"}`}>
              {a.wachtOpOmLabel || (a.allesGedaan ? "Alle deelpunten gedaan · afronden" : a.volgendeLabel || "geen deadline")}{a.dagenTeLaat > 0 && ` · ${a.dagenTeLaat} ${a.dagenTeLaat === 1 ? "dag" : "dagen"} te laat`}
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}

const tijd = (iso) => new Date(iso).toLocaleString("nl-NL", { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export const BesluitChip = () => (
  <span className="inline-flex text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200">Besluit</span>
);

export const ReactieRegel = ({ n, testid }) => (
  <Link to={`/afspraken?select=${n.afspraakId}`} data-testid={testid} className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5 flex-1 min-w-[160px] text-zinc-700 hover:text-blue-700">
    <span><span className="font-semibold capitalize">{n.door}</span> reageerde op · {n.wat}</span>
    {n.besluit && <BesluitChip />}
    <span className="text-xs text-zinc-500">{n.intern ? "Intern" : n.locatie || "Algemeen"}</span>
    <span className="font-mono text-xs text-zinc-400 ml-auto">{n.at ? tijd(n.at) : ""}</span>
  </Link>
);

export const PuntRegel = ({ n, testid }) => (
  <Link to={`/afspraken?select=${n.afspraakId}`} data-testid={testid} className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5 flex-1 min-w-[160px] text-zinc-700 hover:text-blue-700">
    <span><span className="font-semibold">{n.locatie}</span> voegde een punt toe: {n.wat}</span>
    <span className="font-mono text-xs text-zinc-400 ml-auto">{n.at ? tijd(n.at) : ""}</span>
  </Link>
);

export const AfdelingMeldtRegel = ({ n, testid }) => (
  <Link to={`/afspraken?select=${n.afspraakId}`} data-testid={testid} className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5 flex-1 min-w-[160px] text-zinc-700 hover:text-blue-700">
    <span><span className="font-semibold">{n.afdelingNaam}</span> meldt{n.bij === "deadline" ? " bij de deadline" : ""}{n.gereed ? " · gereed" : ""}{n.note ? `: ${n.note}` : ""}</span>
    <span className="text-xs text-zinc-500">{n.locatie || "Algemeen"} · {n.wat}</span>
    <span className="font-mono text-xs text-zinc-400 ml-auto">{n.at ? tijd(n.at) : ""}</span>
  </Link>
);

const regelVoor = (n, i) => (n.soort === "punt" ? <PuntRegel n={n} testid={`vandaag-punt-${i}`} />
  : n.soort === "afdeling-voortgang" ? <AfdelingMeldtRegel n={n} testid={`vandaag-afdeling-meldt-${i}`} />
  : <ReactieRegel n={n} testid={`vandaag-reactie-${i}`} />);

export const ReactiesVoorJou = ({ items, onGezien }) => (items?.length ? (
  <div className="mb-3 md:mb-4" data-testid="vandaag-reacties-voor-jou">
    <SectieBalk testid="vandaag-sectie-reacties" titel={items.some((n) => n.soort !== "reactie") ? "Nieuw voor jou" : "Reacties voor jou"} aantal={items.length} hint="tot je op Gezien drukt, maximaal 14 dagen"
      actie={<button type="button" data-testid="vandaag-reacties-gezien" onClick={onGezien} className={KNOP_IN_KOP}>Gezien</button>} />
    <ul className="bg-white border border-zinc-200 rounded-[10px] divide-y divide-zinc-200">
      {items.map((n, i) => <li key={`${n.afspraakId}-${n.at}-${i}`} className="px-3 py-[9px] text-[13px] flex">{regelVoor(n, i)}</li>)}
    </ul>
  </div>
) : null);

export const InternBlok = ({ items }) => (
  <div className="mb-3 md:mb-4">
    <SectieBalk testid="vandaag-sectie-intern" titel="Interne afspraken met jou" aantal={items.length} />
    <AfspraakLijst items={items} testid="vandaag-intern" leeg="Geen open interne afspraken met jou." />
  </div>
);
